import { endOfDay, setHours, setMinutes, startOfDay } from "date-fns";
import PropTypes from "prop-types";
import { parseDate } from "../../../utils/date";
import DatePickerNative from "./DatePickerNative";
import TimePickerNative from "./TimePickerNative";

function merge(datePart, timePart, fallback) {
  const d = parseDate(datePart);
  const t = parseDate(timePart);
  if (!d) return "";
  if (!t) return fallback(d);
  return setMinutes(setHours(d, t.getHours()), t.getMinutes());
}

function toEvent(id, name, value) {
  const d = parseDate(value);
  const formatedValue = d ? d.toISOString() : "";
  return {
    target: { id: id || name, name: name || id, value: d || "", formatedValue },
  };
}

export default function FromToDateTimePickerNative({ from, to, onChange }) {
  const handleFraDato = (e) => {
    const merged = merge(e.target.value, from.time?.value, startOfDay);
    onChange(toEvent(from.date.id, from.date.name, merged));
  };
  const handleFraTid = (e) => {
    const merged = merge(from.date?.value, e.target.value, startOfDay);
    // Update time field value for UI, then merged date
    onChange(e);
    onChange(toEvent(from.date.id, from.date.name, merged));
  };
  const handleTilDato = (e) => {
    const merged = merge(e.target.value, to.time?.value, endOfDay);
    onChange(toEvent(to.date.id, to.date.name, merged));
  };
  const handleTilTid = (e) => {
    const merged = merge(to.date?.value, e.target.value, endOfDay);
    onChange(e);
    onChange(toEvent(to.date.id, to.date.name, merged));
  };

  return (
    <>
      <DatePickerNative
        id={from.date.id}
        name={from.date.name}
        label={from.date.label}
        placeholder={from.date.placeholder}
        value={from.date.value}
        validationError={from.date.validationError}
        maxDate={to.date.value ? parseDate(to.date.value) : from.date.maxDate}
        onChange={handleFraDato}
      />
      <TimePickerNative
        id={from.time.id}
        name={from.time.name}
        label={from.time.label}
        placeholder={from.time.placeholder}
        value={from.time.value}
        validationError={from.time.validationError}
        onChange={handleFraTid}
      />
      <DatePickerNative
        id={to.date.id}
        name={to.date.name}
        label={to.date.label}
        placeholder={to.date.placeholder}
        value={to.date.value}
        validationError={to.date.validationError}
        minDate={from.date.value ? parseDate(from.date.value) : to.date.minDate}
        onChange={handleTilDato}
      />
      <TimePickerNative
        id={to.time.id}
        name={to.time.name}
        label={to.time.label}
        placeholder={to.time.placeholder}
        value={to.time.value}
        validationError={to.time.validationError}
        onChange={handleTilTid}
      />
    </>
  );
}

FromToDateTimePickerNative.propTypes = {
  from: PropTypes.shape({
    date: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      label: PropTypes.string,
      placeholder: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.string,
      ]),
      validationError: PropTypes.string,
      minDate: PropTypes.instanceOf(Date),
      maxDate: PropTypes.instanceOf(Date),
    }).isRequired,
    time: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      label: PropTypes.string,
      placeholder: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.string,
      ]),
      validationError: PropTypes.string,
    }).isRequired,
  }).isRequired,
  to: PropTypes.shape({
    date: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      label: PropTypes.string,
      placeholder: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.string,
      ]),
      validationError: PropTypes.string,
      minDate: PropTypes.instanceOf(Date),
      maxDate: PropTypes.instanceOf(Date),
    }).isRequired,
    time: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      label: PropTypes.string,
      placeholder: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.string,
      ]),
      validationError: PropTypes.string,
    }).isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
